import checkMustEat from "../mustEat/checkMustEat";
import dhamaMovesInit from "../dhamaMoves/dhamaMovesInit";
import handleSquareClick from "../clickEvent/handleSquareClick";
let temptArrayToremoveSelection = [];
function handleDhamaMoves(
  boardDataRef,
  i,
  j,
  squareRef,
  squareRefPawns,
  boardData,
  setBoardData,
  playerTurn,
  prevSquare,
  setPrevSquare,
  setPlayerTurn,
  x,
  finalAllWays,
  matrixOfPawns,
  dhamaIndex,
  pawnsToEat,
  pawnsInTouch,
  prevSquareIndexForMustEat,
  handleDhamaMovesFromMustEat,
  activeSound,
  mustEatWhithDhamaArray
) {
  const clickedSquareData = boardData.find(
    (square) => square[1] === i && square[2] === j
  );
  const [squareColor, row, col] = clickedSquareData;
  let [prevRow, prevCol] = prevSquare;
  let prevSquareIndex = prevRow * 10 + prevCol;
  const currentSquareIndex = row * 10 + col;
  if (handleDhamaMovesFromMustEat) {
    prevSquareIndex = prevSquareIndexForMustEat;

    prevRow = Math.floor(prevSquareIndex / 10);
    prevCol = prevSquareIndex % 10;
    // }
  }

  if (
    (boardData[prevSquareIndex][0] === 32 && playerTurn === 2) ||
    (boardData[prevSquareIndex][0] === 31 && playerTurn === 1)
  ) {
    // boardDataRef.current[prevSquareIndex][0] = 0;
    if (finalAllWays.length !== 0)
      for (let i = 0; i < finalAllWays.length; i++) {
        for (let j = 0; j < finalAllWays[i].length; j++) {
          if (finalAllWays[i][j].length !== 0) {
            squareRef.current[finalAllWays[i][j]].classList.remove(
              "box-waiting-for-selection"
            );
          }
        }
      }
    var result = dhamaMovesInit(
      prevRow,
      prevCol,
      matrixOfPawns,
      boardData,
      prevSquareIndex,
      playerTurn
    );
    finalAllWays = result.finalAllWays;
    pawnsToEat = result.pawnsToEat;
  }
  const isInDiagonals = finalAllWays.some((diagonal) =>
    diagonal.includes(currentSquareIndex)
  );
  // function isEqualArrays(arr1, arr2) {
  //   if (arr1.length !== arr2.length) {
  //     return false;
  //   }

  //   for (let i = 0; i < arr1.length; i++) {
  //     if (arr1[i] !== arr2[i]) {
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  if (!isInDiagonals) {
    const finalAllWaysString = JSON.stringify(finalAllWays);

    if (
      !temptArrayToremoveSelection.some(
        (array) => JSON.stringify(array) === finalAllWaysString
      ) &&
      finalAllWays.length !== 0 &&
      x === 3
    ) {
      temptArrayToremoveSelection.push(finalAllWays);
    }
    for (let i = 0; i < finalAllWays.length; i++) {
      for (let j = 0; j < finalAllWays[i].length; j++) {
        if (finalAllWays[i][j].length !== 0) {
          squareRef.current[finalAllWays[i][j]].classList.add(
            "box-waiting-for-selection"
          );
        }
      }
    }
  }
  var valid = false;
  if (
    (playerTurn === 2 &&
      boardData[prevSquareIndex][0] === 32 &&
      (boardData[currentSquareIndex][0] === 0 ||
        currentSquareIndex === prevSquareIndex) &&
      isInDiagonals) ||
    (playerTurn === 1 &&
      boardData[prevSquareIndex][0] === 31 &&
      (boardData[currentSquareIndex][0] === 0 ||
        currentSquareIndex === prevSquareIndex) &&
      isInDiagonals)
  ) {
    valid = true;
    boardDataRef.current[prevSquareIndex][0] = 0;
    if (playerTurn === 2) {
      squareRefPawns.current[prevSquareIndex].classList.remove(
        "blue-square",
        "blue-square-dhama"
      );
      boardDataRef.current[currentSquareIndex][0] = 32;
      squareRefPawns.current[currentSquareIndex].classList.add(
        "blue-square-dhama"
      );
      squareRef.current[currentSquareIndex].classList.add("board-square-even");
    } else if (playerTurn === 1) {
      squareRefPawns.current[prevSquareIndex].classList.remove(
        "red-square",
        "red-square-dhama"
      );
      boardDataRef.current[currentSquareIndex][0] = 31;
      squareRefPawns.current[currentSquareIndex].classList.add(
        "red-square-dhama"
      );
      squareRef.current[currentSquareIndex].classList.add("board-square-even");
    }

    for (let i = 0; i < dhamaIndex.length; i++) {
      if (prevSquareIndex === dhamaIndex[i][1]) {
        dhamaIndex[i][1] = currentSquareIndex;
        break;
      }
    }

    for (let i = 0; i < finalAllWays.length; i++) {
      for (let j = 0; j < finalAllWays[i].length; j++) {
        if (finalAllWays[i][j].length !== 0) {
          squareRef.current[finalAllWays[i][j]].classList.remove(
            "box-waiting-for-selection"
          );
        }
      }
    }
    if (pawnsToEat.length > 0) {
      const index = finalAllWays.findIndex((innerArray) =>
        innerArray.includes(currentSquareIndex)
      );
      if (index !== -1) {
        pawnsToEat[index].forEach((indexPawn) => {
          boardDataRef.current[indexPawn][0] = 0;
          squareRefPawns.current[indexPawn].classList.remove(
            "red-square",
            "red-square-dhama",
            "blue-square",
            "blue-square-dhama"
          );
        });
        pawnsToEat = [];
        finalAllWays = [];
      } else {
        // alert("not valid move");
      }
    }
    if (playerTurn === 2) {
      setPlayerTurn(1);
      x = 1;
    } else if (playerTurn === 1) {
      setPlayerTurn(2);
      x = 1;
    }
    if (currentSquareIndex > 11 && currentSquareIndex < 88) {
      checkMustEat(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        playerTurn,
        pawnsInTouch
      );
    }
  }

  if (!valid) {
    if (temptArrayToremoveSelection.length > 0) {
      temptArrayToremoveSelection
        .slice(0, temptArrayToremoveSelection.length - 1)
        .forEach((subArray) => {
          subArray.forEach((element) => {
            element.forEach((index) => {
              squareRef.current[index].classList.remove(
                "box-waiting-for-selection"
              );
            });
          });
        });

      while (temptArrayToremoveSelection.length > 1) {
        temptArrayToremoveSelection.shift();
      }
    }
  }
  if (valid) {
    if (temptArrayToremoveSelection.length > 0) {
      temptArrayToremoveSelection.forEach((subArray) => {
        subArray.forEach((element) => {
          element.forEach((index) => {
            squareRef.current[index].classList.remove(
              "box-waiting-for-selection"
            );
          });
        });
      });

      while (temptArrayToremoveSelection.length > 0) {
        temptArrayToremoveSelection.shift();
      }
    }
  }

  if (
    (((boardData[currentSquareIndex][0] === 32 && x !== 3) ||
      (boardData[currentSquareIndex][0] === 32 &&
        mustEatWhithDhamaArray.includes(currentSquareIndex)) ||
      boardData[currentSquareIndex][0] === 2) &&
      playerTurn === 2 &&
      !valid) ||
    (((boardData[currentSquareIndex][0] === 31 && x !== 3) ||
      (boardData[currentSquareIndex][0] === 31 &&
        mustEatWhithDhamaArray.includes(currentSquareIndex)) ||
      boardData[currentSquareIndex][0] === 1) &&
      playerTurn === 1 &&
      !valid)
  ) {
    if (x !== 3) {
      squareRef.current[prevSquareIndex].classList.remove("gray-box");
      squareRef.current[currentSquareIndex].classList.add("gray-box");

      for (let i = 0; i < finalAllWays.length; i++) {
        for (let j = 0; j < finalAllWays[i].length; j++) {
          if (finalAllWays[i][j].length !== 0) {
            squareRef.current[finalAllWays[i][j]].classList.remove(
              "box-waiting-for-selection"
            );
          }
        }
      }
    }
    setPrevSquare([row, col]);
  } else if (valid) {
    // // ! zidha fi alvalid
    // for (let j = 0; j < temptArrayToremoveSelection[0].length; j++) {
    //   squareRef.current[temptArrayToremoveSelection[0][j]].classList.remove(
    //     "box-waiting-for-selection"
    //   );
    // }
    // // ! zidha fi alvalid

    squareRef.current[prevSquareIndex].classList.remove("gray-box");
    if (prevSquareIndexForMustEat >= 0 && prevSquareIndexForMustEat <= 98) {
      squareRef.current[prevSquareIndexForMustEat].classList.remove("gray-box");
    }
    squareRef.current[prevSquareIndexForMustEat].classList.remove(
      "box-waiting-for-selection"
    );
  }

  if (
    (boardData[prevSquareIndex][0] === 2 && playerTurn === 2) ||
    (boardData[prevSquareIndex][0] === 1 && playerTurn === 1)
  ) {
    x = 1;
    for (let i = 0; i < finalAllWays.length; i++) {
      for (let j = 0; j < finalAllWays[i].length; j++) {
        if (finalAllWays[i][j].length !== 0) {
          squareRef.current[finalAllWays[i][j]].classList.remove(
            "box-waiting-for-selection"
          );
        }
      }
    }
    handleSquareClick(
      boardDataRef,
      i,
      j,
      squareRef,
      squareRefPawns,
      boardData,
      setBoardData,
      playerTurn,
      prevSquare,
      setPrevSquare,
      setPlayerTurn,
      x,
      dhamaIndex,
      pawnsInTouch,
      activeSound
    );
  }
  return [valid, temptArrayToremoveSelection];
}

export default handleDhamaMoves;
